import $ from "jquery";
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { ActivityIndicator, SafeAreaView, StyleSheet, TouchableOpacity, View } from "react-native"
import { ID_BACK, ID_FRONT, SELFIE } from "../../Apps/checkedInScreens/idVerification/verifyIdentity";
import { CROSS } from "../../assets";
import Webcam from "react-webcam";
import { ImageComp } from "../Image/Image";
import IdOverlay from "./idOverlay";
import SelfieOverlay from "./selfieOverlay";
import CustomPressable from "../customPressable/customPressable";
import InfoPopupModal from "../infoPopupModal";
import { useCssStyle } from "../../customHook/getCssStyle";


const CameraComponent = forwardRef(function CameraComponent(props, ref) {

    console.log('Received props:', props);
    const { cameraType = 'back', pictureType, handleImageCapture, handleCloseCamera } = props || {};

    const cameraRef = useRef(null);
    const getStyles = useCssStyle();

    const [cameraPermission, setCameraPermission] = useState(true);

    const [cameraLoading, setCameraLoading] = useState(true);
    const [width, setWidth] = useState()
    const [height, setHeight] = useState()
    const [videoConstraints, setVideoConstraints] = useState()

    const [disableCaptureButton, setDisableCaptureButton] = useState(false)



    const captureImage = useCallback(
        () => {
            const imageSrc = cameraRef.current?.getScreenshot();
            handleImageCapture(imageSrc);
        },

        // eslint-disable-next-line react-hooks/exhaustive-deps
        [cameraRef]
    );

    useImperativeHandle(ref, () => ({
        takePicture: captureImage,
    }));

    const handleCaptureButton = () => {
        setDisableCaptureButton(true);
        captureImage();
    }

    const handleBack = () => {
        handleCloseCamera();
    }

    useEffect(() => {

        const handleOrientationChange = () => {

            setCameraLoading(true);

            setTimeout(() => {

                if (window.screen.orientation.type == "landscape-primary" || window.screen.orientation.type == "landscape-secondary") {

                    setWidth(window.innerWidth)
                    setHeight(window.innerHeight)
                    setVideoConstraints((prevData) => ({
                        ...prevData,
                        width: window.innerWidth,
                        height: window.innerHeight,
                    }))

                    setCameraLoading(false);

                    if (window.screen.orientation.type == "landscape-primary") {
                        $("body").addClass("orientright");
                    } else if (window.screen.orientation.type == "landscape-secondary") {
                        $("body").addClass("orientleft");
                    }

                } else {

                    $("body").removeClass("orientleft");
                    $("body").removeClass("orientright");

                    setWidth(window.screen.width)
                    setHeight(window.screen.height)

                    setVideoConstraints((prevData) => ({
                        ...prevData,
                        width: window.innerHeight,
                        height: window.innerWidth,
                    }))

                    setCameraLoading(false);
                }

            }, 100);
        }

        window.addEventListener("orientationchange", handleOrientationChange);
        handleOrientationChange();

        return () => {
            $("body").removeClass("orientleft");
            $("body").removeClass("orientright");
            window.removeEventListener("orientationchange", handleOrientationChange);
        }

    }, [])

    return (
        <>
            {!cameraLoading && <Webcam
                ref={cameraRef}
                style={{ width: "100%", height: "100%", flex: 1 }}
                videoConstraints={{ ...videoConstraints, facingMode: cameraType === 'front' ? 'user' : 'environment' }}
                screenshotFormat="image/jpeg"
                mirrored={cameraType == "front" ? true : false}
                onUserMedia={() => setCameraPermission(true)}
                onUserMediaError={() => setCameraPermission(false)}
            />}

            {
                cameraLoading ?
                    <View style={getStyles(['cameraRootContainer'])}>
                        <InfoPopupModal
                            subtitle={'We are unable to access camera. Please grant camera permission.'}
                            onContinue={handleBack}
                            primaryBtnLabel={"Back"}
                        />
                    </View>
                    :
                    <>
                        <SafeAreaView style={getStyles(['safeArea','crossOverContainer_Container'])}>
                            <CustomPressable style={getStyles(['crossOverContaniner_Cross'])} onPress={handleBack}>
                                <ImageComp source={CROSS} />
                            </CustomPressable>
                        </SafeAreaView>

                        <CustomPressable style={getStyles(['captureButton'])} disabled={disableCaptureButton} onPress={handleCaptureButton}>
                            <View style={getStyles(['captureButton_innerCircle'])} />
                        </CustomPressable>
                    </>
            }
        </>
    )
});

export default CameraComponent;